import { useEffect, useState } from 'react';

import { getReceptacleActionHistoryList, getReceptaclesList, updateReceptacle } from '../../../api';
import { formatDate } from '../../../utils/date';
import updateReceptacleInvoice from '../../../api/receptacle/updateReceptacleInvoice';
import deleteInvoiceNumber from '../../../api/receptacle/deleteInvoiceNumber';

export const useReceptaclesList = (recordId, search) => {
  const [data, updateData] = useState([]);
  const [loading, updateLoading] = useState(false);

  const updateStatusReceptacles = async (ids, settlementStatus, comments = '') => {
    updateLoading(true);
    const entities = ids.map(id => ({ id, comments }));
    const response = await updateReceptacle({ entities, approvalAction: settlementStatus });

    if (response) {
      const updatedData = data.map((item) => {
        const itemIndex = response.findIndex(updated => updated.id === item.id);
        if (itemIndex > -1) {
          item.settlementStatus = response[itemIndex].settlementStatus;
          item.comments = response[itemIndex].comments;
        }

        return item;
      });

      updateData(updatedData);
      updateLoading(false);
    }
  };

  const deleteReceptaclesInvoiceNumber = receptacleId => async () => {
    updateLoading(true);
    const resp = await deleteInvoiceNumber(receptacleId);
    if (resp !== undefined) {
      const updatedData = data.map((item) => {
        if (item.id === receptacleId) {
          item.invoiceNumber = resp.invoiceNumber;
          item.commentCreator = resp.deleteActionAuthor;
          item.lastCommentUpdate = resp.deleteDate;
        }
        return item;
      });

      updateData(updatedData);
      updateLoading(false);
    }
  };

  const getReceptacleActionHistory = receptacleId => async () => {
    updateLoading(true);
    const resp = await getReceptacleActionHistoryList({ receptacleSnapshotId: receptacleId });
    updateLoading(false);
    return resp;
  };

  const updateReceptaclesInvoiceNumber = async (ids, invoiceNumberToUpdate = '') => {
    updateLoading(true);
    const receptaclesToUpdate = { receptacleIds: ids, invoiceNumber: invoiceNumberToUpdate, lastInvoiceUpdate: formatDate(new Date(), 'DD/MM/YYYY') };
    const response = await updateReceptacleInvoice(receptaclesToUpdate);

    if (response) {
      const updatedData = data.map((item) => {
        const itemIndex = response.findIndex(updated => updated.id === item.id);
        if (itemIndex > -1) {
          item.lastInvoiceUpdate = response[itemIndex].lastInvoiceUpdate;
          item.invoiceNumber = response[itemIndex].invoiceNumber;
          item.invoiceCreator = response[itemIndex].invoiceCreator;
        }

        return item;
      });

      updateData(updatedData);
      updateLoading(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      updateLoading(true);
      let response;
      if (recordId) {
        response = await getReceptaclesList(recordId, null);
      } else if (search) {
        response = await getReceptaclesList(null, search);
      } else {
        response = await getReceptaclesList(null, null);
      }
      updateLoading(false);

      if (response) {
        updateData(response);
      }
    };

    fetchData();
  }, [recordId, search]);

  return [data, loading, updateStatusReceptacles, updateReceptaclesInvoiceNumber, deleteReceptaclesInvoiceNumber, getReceptacleActionHistory];
};
